<template>
    <div>
        <div class="button is-left" @click="addNewMessage">
            <span>Añadir salto de mensaje</span>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            syntax: '[SALTO_MENSAJE]'
        }
    },
    methods: {
        addNewMessage () {
            this.$emit('new-message', this.syntax)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/NewMessageButton.vue